import styled, { css } from "styled-components";

interface PriceViewGridBaseProps {
	isFlash?: boolean;
}
export const PriceViewGridBase = styled.section`
	margin: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	.currentPrice {
		height: 19px;
		line-height: 19px;
		font-size: 14px;
		font-weight: 800;
		font-family: avenir, sans-serif;
		margin-left: 1px;
		color: ${props => props?.theme?.mainFontColor};
		white-space: nowrap;
		margin-right: 9px;
	}

	.originPrice {
		line-height: 19px;
		text-decoration: line-through;
		color: #999;
		font-size: 12px;
		font-weight: 400;
		vertical-align: middle;
	}
	${(props: PriceViewGridBaseProps) => {
		if (props.isFlash) {
			return css`
				.originPrice {
					font-family: var(--fontBold);
				}
			`;
		}
		return css``;
	}}
`;
